// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__12yO1","icon":"SortAdornment_icon__1mfDI","up":"SortAdornment_up__tTBqI","down":"SortAdornment_down__3UXPy","active":"SortAdornment_active__1CyR1"};